import { render, staticRenderFns } from "./profileform.vue?vue&type=template&id=05c4a575&scoped=true&"
import script from "./profileform.vue?vue&type=script&lang=js&"
export * from "./profileform.vue?vue&type=script&lang=js&"
import style0 from "./profileform.vue?vue&type=style&index=0&id=05c4a575&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c4a575",
  null
  
)

export default component.exports